import { Hide, Text } from '@chakra-ui/react';
import { useField } from 'formik';
import { CheckboxControl } from 'formik-chakra-ui';
import { useState } from 'react';

interface Props {
    pronoun?: string;
    career?: string;
    type: 'rounded-centered' | 'careers' | 'tools';
    onClick?: (value: string) => void;
    onChange?: any;
    onInputChange?: (value: string) => void;
    name: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    text?: string;
    column?: boolean;
    width?: string;
}

const CreateProfileButton = ({ ...props }: Props) => {
    const [field, meta] = useField(props.name);

    const [isChecked, setIsChecked] = useState(props);

    const [isDisabled, setIsDisabled] = useState(props.isDisabled);

    if (props.type === 'rounded-centered') {
        return (
            <CheckboxControl
                className='roundedbutton'
                name={props.name}
                width={props.width ? props.width : "350px"}
                value={props.text as string}
                height="48px"
                borderRadius="100px"
                icon={<Hide></Hide>}
                border="1px solid #E1E0E3"
                _checked={{
                    border: '1px solid transparent',
                    background:
                        'linear-gradient(white 0 0) padding-box, linear-gradient(to left, #FF53BA, #178BFF) border-box',
                    borderRadius: '100px',
                    display: 'flex',
                    padding: '0 -24px'
                }}
                mb={ props.column ? '8px': '0px'}
                mt='2px'
                children={
                    isChecked ? (
                        <Text width="350px" marginLeft="-2">
                            {props.text}
                        </Text>
                    ) : (
                        <Text width="350px" marginLeft="-2">
                            {props.text}
                        </Text>
                    )
                }
            />
        );
    } else {
        return (
            <CheckboxControl
                {...field}
                className='roundedbutton'
                onChange={props.onChange ? (e) => {
                    field.onChange(e);
                    props.onChange(e);
                } : (e) => field.onChange(e)}
                name={props.name}
                width="full"
                value={props.text as string}
                height="48px"
                borderRadius="100px"
                icon={<Hide></Hide>}
                border="1px solid #E1E0E3"
                isChecked={props.isChecked}
                isDisabled={isDisabled}
                _checked={
                {
                    outline: 'solid 2.5px white',
                    border: '1px solid transparent',
                    background:
                        'linear-gradient(white 0 0) padding-box, linear-gradient(to left, #FF53BA, #178BFF) border-box',
                    borderRadius: '100px',
                    display: 'flex',
                    padding: '0 -24px'
                }
            }
                mt="10px"
                sx={{}}
            >
                <Text ml="10px">{props.text}</Text>
            </CheckboxControl>
        );
    }
};

export default CreateProfileButton;
